// @team BFA Acquisition
import flow from 'lodash/flow';

import Quiz from '../../../../features/Quiz/pages/Quiz';
import { withApolloContext } from '../../../../utils/apollo';

const Cmp = flow(withApolloContext({ ssr: true }))(Quiz);

Cmp.displayName = 'Quiz/Retake/Questions';

export default Cmp;
